import React, { Component } from "react";
import styles from "./userInformation.module.scss";
import { withUsers } from "../../../shared/containers/containerUsers";
import { Checkbox } from "@mui/material";
import { states } from "../../../reducers/queriesStates";
import configuration from "./../../../config.json";
import { TextField } from "@mui/material";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { withAuth } from "../../../shared/containers/containerAuth";

class UserInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      password: "",
    };
  }

  componentDidUpdate(prevProps) {
    const { blockStatesDataState, errors, updateUserPasswordDataState } = this.props;

    if (
      (blockStatesDataState === states.FAILURE && prevProps.blockStatesDataState === states.REQUEST) ||
      (updateUserPasswordDataState === states.FAILURE && prevProps.updateUserPasswordDataState === states.REQUEST)
    ) {
      this.setState({ error: errors });

      setTimeout(() => {
        this.setState({ error: null });
      }, 3000);
    }

    if (updateUserPasswordDataState === states.READY && prevProps.updateUserPasswordDataState === states.REQUEST) {
      this.setState({ password: "", error: null });
    }
  }

  onBlockedStateCheket(e) {
    const { onBlockStates, currentUser } = this.props;

    onBlockStates(currentUser.id, e.target.checked);
  }

  changePassword(e) {
    this.setState({ password: e.target.value, error: null });
  }

  handleClickButton() {
    const { onUpdateUserPassword, currentUser } = this.props;
    const { password } = this.state;

    onUpdateUserPassword(currentUser.id, { password });
  }

  render() {
    const { currentUser, data, updateUserPasswordDataState } = this.props;
    const { password, error } = this.state;

    if (!currentUser) {
      return null;
    }

    const dateCreation = new Date(Date.parse(currentUser.dateCreation));
    const dateLastSignIn = new Date(Date.parse(currentUser.dateLastSignIn));

    return (
      <div className={styles.userInformationContainer}>
        <div>
          <span>
            Почта: <strong>{currentUser.email}</strong> <span className={styles.error}>{error}</span>
          </span>
        </div>
        <div>
          <span>
            ФИО: <strong>{currentUser.title}</strong>
          </span>
        </div>
        <div>
          <span>
            Роль пользователя: <strong>"{currentUser.role.title}"</strong>
          </span>
        </div>

        <div>
          Создан:{" "}
          <span>{new Date(dateCreation.setHours(-new Date().getTimezoneOffset() / 60 + dateCreation.getHours())).toLocaleString()}</span>
        </div>
        <div>
          Вход:{" "}
          <span>
            {new Date(dateLastSignIn.setHours(-new Date().getTimezoneOffset() / 60 + dateLastSignIn.getHours())).toLocaleString()}
          </span>
        </div>
        <div>
          <Checkbox
            checked={currentUser.isBlocked}
            onChange={this.onBlockedStateCheket.bind(this)}
            style={{
              padding: "0px",
              color: "red",
              transform: "scale(1)",
            }}
          />
          <span>Заблокированый пользователь</span>
        </div>

        {configuration.isLocalApp && configuration.localAppConfig.userWithoutEmail && data.permissions.includes(20014) ? (
          <div className={styles.userRestorePasswordToolContainer}>
            <div>
              <TextField
                size="small"
                label="Пароль"
                inputProps={{ sx: { width: "300px" } }}
                variant="outlined"
                value={password}
                onChange={this.changePassword.bind(this)}
              />
            </div>
            <div>
              {updateUserPasswordDataState !== states.REQUEST ? (
                <ButtonPrimary disabled={password.length < 6} handleClick={this.handleClickButton.bind(this)} title="Обновить пароль" />
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withAuth(withUsers(UserInformation));
